import "./style.css";
import React from "react";

import Container from "components/Container";
import Link from "components/Link";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronCircleUp } from "@fortawesome/free-solid-svg-icons";
import { faGithub, faLinkedin } from "@fortawesome/free-brands-svg-icons";
import { NavLink } from "react-router";

export default function Footer() {
	return (
		<Container containerClass="footer-container">
			<Container
				containerClass="scroll-to-top"
				onClick={() =>
					window.scroll({ top: 0, left: 0, behavior: "smooth" })
				}
			>
				<FontAwesomeIcon
					icon={faChevronCircleUp}
					className="expand-sm"
					title="Tillbaka till toppen av sidan"
				/>
			</Container>
			<Container containerClass="social-icons">
				<Link
					href="https://www.linkedin.com/in/abraham-eishow/"
					linkTitle="Min Linkedin profil"
					iconClass="link-linkedin"
					faIcon={faLinkedin}
				/>
				<Link
					href="https://github.com/Abrei852"
					linkTitle="Min Github sida"
					iconClass="link-github"
					faIcon={faGithub}
				/>
			</Container>
			<NavLink
				className="contact expand-sm"
				to="/kontakta-mig"
			>
				kontakta mig
			</NavLink>
			<p className="copyright">
				copyright&copy; {new Date().getFullYear()} | abraham eishow |
				all rights reserved
			</p>
		</Container>
	);
}
